import React, { useEffect, useState } from "react";
import bg2 from "./assets/Roadmap-bg.png";
import h1 from "./assets/h1.png";
import h2 from "./assets/h2.png";
import useMediaQuery from "@mui/material/useMediaQuery";
import "./Roadmap.css";
import { Box } from "@mui/system";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";

// import Hearts from './assets/hearts.png'
import purple from "./assets/pinkheart.png";

function Roadmap() {
  const [scroll, setScroll] = useState();
  const check = useMediaQuery("(max-width:1169px)");
  const aboveScreen = useMediaQuery("(min-width:1469px)");
  const small = useMediaQuery("(max-width:380px)");
  const matches = useMediaQuery("(max-width:1169px)");
  const clientScreenMatches = useMediaQuery("(min-width:1920px)");
  const purpleheartHanle = useMediaQuery("(max-width:500px)");
  const [innerWidth, setInnerWidth] = useState(window.innerWidth);
  const [_hearMovey, _SetHearMovey] = React.useState(0);
  const [boxOne, setBoxOne] = React.useState(0);
  const [boxTwo, setBoxTwo] = React.useState(0);
  const [boxThree, setBoxhree] = React.useState(0);
  const [boxFour, setBoxFour] = React.useState(0);
  const [boxFive, setBoxFive] = React.useState(0);
  const [boxSix, setBoxSix] = React.useState(0);
  const contentStyle = {
    background: "#511D66",
    border: "3px solid #F3ADB4 ",
    color: "white",
    height: small ? "330px" : "200px",
    borderRadius: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    boxShadow: "none",
    backgroundBlur: "20px",
  };

  const iconStyle = {
    background: "#F3ADB4",
    color: "black",
    display: "flex ",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "60px",
    height: "34px",
    width: "34px",
    border: "none",
    marginLeft: check ? "" : "-17px",
  };

  const [left, setleft] = useState(0);

  // React.useEffect(() => {
  //   const handleScroll = () => {
  //     const offsetDotOne = document.getElementById("dotOne").offsetTop;
  //     // const offsetRoadMap = document.getElementById("roadmap").offsetTop;
  //     const offsetDotTow = document.getElementById("dotTwo").offsetTop;
  //     const offsetDotThree = document.getElementById("dotThree").offsetTop;
  //     const offsetDotFour = document.getElementById("dotFour").offsetTop;
  //     const offsetDotFive = document.getElementById("dotFive").offsetTop;
  //     const offsetDotSix = document.getElementById("dotSix").offsetTop;
  //     _SetHearMovey(window.scrollY);
  //     setBoxOne(offsetDotOne + 1940 + 1000);
  //     setBoxTwo(offsetDotTow + 1950);
  //     setBoxhree(offsetDotThree + 1950);
  //     setBoxFour(offsetDotFour + 1950);
  //     setBoxFive(offsetDotFive + 1950);
  //     setBoxSix(offsetDotSix + 1850);
  //   };
  //   window.addEventListener("scroll", handleScroll);
  // }, []);

  // useEffect(() => {
  //   var img = document.getElementById("heartImage");
  //   console.log(img.clientWidth, "widhtof Imge");

  //   function handleResize() {
  //     setInnerWidth(window.innerWidth);
  //   }
  //   window.addEventListener("resize", handleResize);
  //   let currentWidth = window.innerWidth;
  //   if (purpleheartHanle) {
  //     let Division = innerWidth - img.clientWidth - 110;
  //     setleft(Division / 2);
  //   } else {
  //     let Division = currentWidth - img.clientWidth - 60;
  //     setleft(Division / 2);
  //   }
  // }, [purpleheartHanle, innerWidth, scroll, _hearMovey]);

  // console.log(_hearMovey, "_hearMovey");
  // React.useEffect(() => {
  //   // console.log(_hearMovey, "_hearMovey");
  //   // let a = 1;
  //   if (+_hearMovey < +boxTwo) {
  //     // a = a + 2;
  //     console.log(_hearMovey, _hearMovey / 70 + 4);
  //   }
  // }, [_hearMovey]);
  // console.log(_hearMovey / 2, "_hearMovey");

  useEffect(() => {
    let element = document.getElementsByClassName("dualback");
    console.log(element);
  }, []);

  const matches2 = useMediaQuery("(min-width:2500px)");
  const matches3 = useMediaQuery("(min-width:3500px)");
  const matches4 = useMediaQuery("(min-width:4300px)");

  return (
    <div
      style={{
        marginTop: "-50px",
        textAlign: "center",
        position: "relative",

        // paddingTop: "180px",
      }}
    >
      <img
        className={"zoom-in-out-box" + " " + "animat"}
        style={{
          marginTop: "-50px",
          textAlign: "center",
          backgroundImage: `url(${purple})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "auto",
          backgroundPosition: "50% 6%",
          zIndex: "999",

          // paddingTop: "180px",
        }}
        src={purple}
      />
      {/* <Grid container sx={{maxWidth:"1000px"}} justifyContent="center">
          <Grid item xs={5} textAlign={"left"}>
          <Box bgcolor="red">
      <img style={{width:"100%",maxWidth:"300px",height:"auto",position:"absolute",marginTop:"-30px"}} src={Hearts} />
      </Box>
          </Grid>
          <Grid item xs={1} textAlign={"center"}>
          <Box bgcolor="yellow">
      <img style={{width:"100%",maxWidth:"143px",position:"absolute",marginTop:"-30px"}} src={purple} />
      </Box>
          </Grid>
          <Grid item xs={5} textAlign={"right"}>
          <Box bgcolor="red">
      <img style={{width:"100%",maxWidth:"300px",height:"auto",position:"absolute",marginTop:"-30px"}} src={Hearts} />
      </Box>
          </Grid>
      </Grid> */}

      {/* <Box bgcolor="red">
      <img style={{width:"100%",maxWidth:"300px",height:"auto",position:"absolute",marginTop:"-30px"}} src={Hearts} />
      </Box>
      <Box bgcolor="yellow">
      <img style={{width:"100%",maxWidth:"143px",position:"absolute",marginTop:"-30px"}} src={purple} />
      </Box> */}

      {/* This is heart img code */}

      <Box
        className="dualback"
        mt={-50}
        sx={{
          padding: "150px 0px 0px 0px",
          backgroundImage: `url(${bg2})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center top",
        }}
        width="100%"
        boxSizing="border-box"
      >
        <Box
          // id="roadmap"
          pt="150px"
          textAlign="center"
          fontSize={{ xs: "30px", md: "55px" }}
          fontWeight="700"
          color="white"
          mb="100px"
          mt={matches2 ? 40 : matches3 ? 80 : 10}
          sx={{
            fontFamily: "'Baloo Bhai 2', cursive",
            textShadow: "0px 0px 20px #FFFFFF",
            zIndex: "1",
            position: "relative",
          }}
        >
          SOULMAPES ROADMAP
        </Box>
        {/* //animations  */}
        <Box bgcolor="red" sx={{ position: "relative" }}>
          <img
            className="zoom-in-out-box"
            alt=""
            style={{
              position: "absolute",
              right: "100px",
              top: "30px",
              zIndex: "9",
              width: "170px",
            }}
            src={h1}
          />
        </Box>

        <Box bgcolor="red" sx={{ position: "relative" }}>
          <img
            className="zoom-in-out-box"
            alt=""
            style={{
              position: "absolute",
              left: "80px",
              top: "250px",
              zIndex: "9",
              width: "110px",
            }}
            src={h2}
          />
        </Box>

        <Box bgcolor="red" sx={{ position: "relative" }}>
          <img
            className="zoom-in-out-box"
            alt=""
            style={{
              position: "absolute",
              right: "100px",
              top: "950px",
              zIndex: "9",
              width: "120px",
            }}
            src={h1}
          />
        </Box>
        <Box bgcolor="red" sx={{ position: "relative" }}>
          <img
            className="zoom-in-out-box"
            alt=""
            style={{
              position: "absolute",
              left: "80px",
              top: "1150px",
              zIndex: "9",
              width: "150px",
            }}
            src={h2}
          />
        </Box>

        <Box color="white" pb="40px">
          <VerticalTimeline>
            <VerticalTimelineElement
              id="dotOne"
              className="vertical-timeline-element--work"
              contentStyle={contentStyle}
              contentArrowStyle={{ border: "0px" }}
              dateClassName="date"
              iconStyle={iconStyle}
              icon={
                <Box
                  fontSize="20px"
                  fontFamily="Josefin Sans"
                  fontWeight="bold"
                ></Box>
              }
            >
              <Box
                pt={1}
                width={{ xs: "100%" }}
                fontWeight="700"
                fontSize={{ xs: "18px", sm: "32px" }}
              >
                {" "}
                10%{" "}
              </Box>

              <Box
                width={{ xs: "100%" }}
                fontWeight="500"
                fontSize={{ xs: "16px", sm: "20px" }}
              >
                After mint, we’ll be airdropping 1/1’s to Soulmapes holders.
                This will be done via live stream to ensure fairness and
                transparency.
              </Box>
            </VerticalTimelineElement>

            {/* element 2  */}

            <VerticalTimelineElement
              id="dotTwo"
              contentStyle={contentStyle}
              dateClassName="date"
              contentArrowStyle={{ border: "0px" }}
              iconStyle={iconStyle}
              icon={
                <Box
                  fontSize="20px"
                  fontFamily="Josefin Sans"
                  fontWeight="bold"
                ></Box>
              }
            >
              <Box
                pt={1}
                width={{ xs: "100%" }}
                fontWeight="700"
                fontSize={{ xs: "18px", sm: "32px" }}
              >
                {" "}
                20%{" "}
              </Box>
              <Box fontWeight="500" fontSize={{ xs: "16px", sm: "20px" }} p={2}>
                Soulmapes’ merchandise, made for him and her. Not the usual
                boring NFT merch, but actually thoughtful and creative
                merchandise for him and her.
              </Box>
            </VerticalTimelineElement>

            {/* change */}

            <VerticalTimelineElement
              id="dotThree"
              contentStyle={{
                background: "#511D66",
                border: "3px solid #F3ADB4 ",
                color: "white",
                height: small ? "330px" : "200px",
                borderRadius: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                boxShadow: "none",
                backgroundBlur: "20px",
              }}
              contentArrowStyle={{ border: "none" }}
              dateClassName="date"
              iconStyle={iconStyle}
            >
              <Box
                pt={1}
                width={{ xs: "100%" }}
                fontWeight="700"
                fontSize={{ xs: "18px", sm: "32px" }}
              >
                {" "}
                50%{" "}
              </Box>
              <Box fontWeight="500" fontSize={{ xs: "16px", sm: "20px" }} p={2}>
                Q&A with relationship experts, topics voted by members
              </Box>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              id="dotFour"
              className="vertical-timeline-element--work"
              contentArrowStyle={{ border: "none" }}
              contentStyle={contentStyle}
              dateClassName="date"
              iconStyle={iconStyle}
              icon={
                <Box
                  fontSize="20px"
                  fontFamily="Josefin Sans"
                  fontWeight="bold"
                ></Box>
              }
            >
              <Box
                pt={1}
                width={{ xs: "100%" }}
                fontWeight="700"
                fontSize={{ xs: "18px", sm: "32px" }}
              >
                {" "}
                75%{" "}
              </Box>
              <Box fontWeight="500" fontSize={{ xs: "16px", sm: "20px" }} p={2}>
                Exclusive access to events, dinner dates, and couple retreats.
              </Box>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              id="dotFive"
              className="vertical-timeline-element--education"
              contentStyle={contentStyle}
              contentArrowStyle={{ border: "0px" }}
              dateClassName="date"
              iconStyle={iconStyle}
              icon={
                <Box
                  fontSize="20px"
                  fontFamily="Josefin Sans"
                  fontWeight="bold"
                ></Box>
              }
            >
              <Box
                pt={1}
                width={{ xs: "100%" }}
                fontWeight="700"
                fontSize={{ xs: "18px", sm: "32px" }}
              >
                {" "}
                90%{" "}
              </Box>
              <Box fontWeight="500" fontSize={{ xs: "16px", sm: "20px" }} p={2}>
                Digital Lovelocks & Bridge of Love is built in the Metaverse.
              </Box>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              id="dotSix"
              contentStyle={contentStyle}
              contentArrowStyle={{ border: "0px" }}
              className="vertical-timeline-element--education"
              dateClassName="date"
              iconStyle={iconStyle}
              icon={
                <Box
                  fontSize="20px"
                  fontFamily="Josefin Sans"
                  fontWeight="bold"
                ></Box>
              }
            >
              <Box
                pt={1}
                width={{ xs: "100%" }}
                fontWeight="700"
                fontSize={{ xs: "18px", sm: "32px" }}
              >
                {" "}
                100%{" "}
              </Box>
              <Box fontWeight="500" fontSize={{ xs: "16px", sm: "20px" }} p={2}>
                Roadmap 2.0: More perks to come, stay tuned!
              </Box>
            </VerticalTimelineElement>
          </VerticalTimeline>
        </Box>
        {/* </Container> */}
      </Box>
    </div>
  );
}

export default Roadmap;
